// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

document.addEventListener("turbo:before-cache", () => {
  const deckEl = document.querySelector("[data-controller='deck']")
  if (!deckEl) return

  const isNewPage = !deckEl.dataset.deckExistingStateValue

  if (isNewPage) {
    const deckArea = document.querySelector(".deck-cards-area")
    if (deckArea) {
      deckArea.querySelectorAll("[data-deck-target='slotCard']").forEach(el => el.remove())
      deckArea.querySelectorAll("[data-deck-target='addedCard']").forEach(el => el.remove())
      const placeholder = deckArea.querySelector("[data-deck-target='placeholder']")
      if (placeholder) placeholder.classList.remove("hidden")
    }

    const leftExtras = document.querySelector("[data-deck-target='leftColumnExtras']")
    if (leftExtras) leftExtras.classList.add("hidden")

    const trigger = document.querySelector(".card-picker-trigger")
    if (trigger) trigger.classList.add("hidden")

    document.querySelectorAll("[data-character-picker-target='selectedCard']").forEach(el => {
      el.classList.add("hidden")
    })
    const charPlaceholder = document.querySelector("[data-character-picker-target='placeholder']")
    if (charPlaceholder) charPlaceholder.classList.remove("hidden")
  } else {
    const deckArea = document.querySelector(".deck-cards-area")
    if (deckArea) {
      deckArea.querySelectorAll("[data-deck-target='slotCard']").forEach(el => el.remove())
      deckArea.querySelectorAll("[data-deck-target='addedCard']").forEach(el => el.remove())
    }
  }
})
